import type { LocationRecord, LocationSchema } from '@libs/data-access/entities'
import type { FC } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { useDefaultBreakValue } from '../../hooks'
import { BreakRowsContainer } from '../BreakRowsContainer/BreakRowsContainer'

type Props = {
  isShiftLocked: boolean
  isBreakPaid: boolean
  isManager: boolean
  shiftId?: number
  location: LocationRecord | LocationSchema
  displayFloatingBreaksWarning: boolean
}

export const AutomaticBreakRowsContainer: FC<Props> = ({
  isShiftLocked,
  isBreakPaid,
  isManager,
  shiftId,
  location,
  displayFloatingBreaksWarning
}) => {
  const { control } = useFormContext()
  const shiftTimeRange = useWatch({ control, name: 'shift_time_range' }) as [
    string,
    string
  ]

  const defaultBreakValue = useDefaultBreakValue({
    location,
    shiftTimeRange,
    shiftId
  })

  return (
    <BreakRowsContainer
      isShiftLocked={isShiftLocked}
      isBreakPaid={isBreakPaid}
      isManager={isManager}
      defaultDuration={defaultBreakValue}
      shiftTimeRange={shiftTimeRange}
      displayFloatingBreaksWarning={displayFloatingBreaksWarning}
    />
  )
}
